'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationField = exports.LocationFieldUnwrapped = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _object = require('helpers/object');

var _LocalizableMessageShape = require('components/LocalizableMessage/LocalizableMessageShape');

var _Location = require('./Items/Location');

var _SearchBoxNoResults = require('./Items/SearchBoxNoResults');

var _SearchBoxField = require('./SearchBoxField');

var _SearchBox = require('./SearchBox.helpers');

var _SearchBox2 = require('./SearchBox.constants');

var _PanelSection = require('./PanelSection');

var _Loader = require('./Loader');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemToString = function itemToString(i) {
  return (i && i.locationName || '').replace(/<[^>]*>/g, '');
};
var locationIconPath = require('../../../../static/design-system/icons/pin.svg');

var messages = (0, _reactIntl.defineMessages)({
  noMatches: {
    id: 'searchbox.item.noMatches',
    defaultMessage: 'No matches'
  },
  placeholder: {
    id: 'searchbox.locationField.placeholder',
    defaultMessage: 'City, neighborhood'
  },
  searchPrompt: {
    id: 'searchbox.item.searchPrompt',
    defaultMessage: 'Try searching by city or neighborhood'
  }
});

var LocationFieldUnwrapped = exports.LocationFieldUnwrapped = function LocationFieldUnwrapped(props) {
  return _react2.default.createElement(
    _SearchBoxField.SearchBoxField,
    (0, _extends3.default)({}, (0, _object.pick)((0, _keys2.default)(_SearchBoxField.SearchBoxField.propTypes), props), {
      itemToString: itemToString,
      isClearable: false,
      icon: _react2.default.createElement(_reactInlinesvg2.default, { src: locationIconPath }),
      placeholder: props.intl.formatMessage(messages.placeholder),
      blurredValue: (0, _typeof3.default)(props.blurredValue) === 'object' ? props.intl.formatMessage(props.blurredValue) : props.blurredValue
    }),
    function (_ref) {
      var getItemProps = _ref.getItemProps,
          highlightedIndex = _ref.highlightedIndex,
          inputValue = _ref.inputValue,
          onPanelScroll = _ref.onPanelScroll;
      var history = props.history,
          intl = props.intl,
          isLoading = props.isLoading,
          onRemoveItem = props.onRemoveItem,
          suggestions = props.suggestions;

      var _ref2 = inputValue ? [suggestions, _SearchBox2.LOCATION_TYPES.autocomplete] : [history, _SearchBox2.LOCATION_TYPES.history],
          _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
          items = _ref3[0],
          itemType = _ref3[1];

      var normalizer = (0, _SearchBox.getItemNormalizer)(itemType);
      var hasResults = items && items.length > 0;

      var sectionItems = void 0;
      if (isLoading) {
        sectionItems = _react2.default.createElement(_Loader.Loader, null);
      } else if (hasResults) {
        sectionItems = items.map(function (item, index) {
          var normalizedItem = normalizer(item);
          return _react2.default.createElement(_Location.Location, (0, _extends3.default)({}, getItemProps({
            item: normalizedItem,
            key: normalizedItem.place_id,
            searchId: normalizedItem.location_id,
            highlighted: index === highlightedIndex,
            onRemoveClick: onRemoveItem
          }), {
            item: normalizedItem
          }));
        });
      } else {
        var noResultsMessage = inputValue ? intl.formatMessage(messages.noMatches) : intl.formatMessage(messages.searchPrompt);
        sectionItems = _react2.default.createElement(_SearchBoxNoResults.SearchBoxNoResults, { message: noResultsMessage });
      }

      return _react2.default.createElement(
        'div',
        { className: 'dropdown searchbox__panel', onScroll: onPanelScroll },
        _react2.default.createElement(
          'div',
          { className: 'dropdown__content' },
          _react2.default.createElement(
            _PanelSection.PanelSection,
            null,
            sectionItems
          )
        )
      );
    }
  );
};

LocationFieldUnwrapped.propTypes = (0, _extends3.default)({
  blurredValue: _LocalizableMessageShape.LocalizableMessageShape,
  isLoading: _propTypes2.default.bool.isRequired,
  onRemoveItem: _propTypes2.default.func.isRequired,
  history: _propTypes2.default.array,
  suggestions: _propTypes2.default.array
}, (0, _object.omit)(['prompt', 'itemToString', 'children', 'blurredValue'], _SearchBoxField.SearchBoxField.propTypes));

var LocationField = exports.LocationField = (0, _reactIntl.injectIntl)(LocationFieldUnwrapped);